import { render, staticRenderFns } from "./RmaProductFilters.vue?vue&type=template&id=9855cca0&"
import script from "./RmaProductFilters.vue?vue&type=script&lang=js&"
export * from "./RmaProductFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports